<div class="header" [class.alert-banner]="showAlert">
  <app-header-desktop class="header-desktop"></app-header-desktop>
  <app-header-mobile class="header-mobile"></app-header-mobile>
  <app-information-alert *ngIf="showInformation" [data]="alertInformation" (clickCloseInformation)="closeInformation()"></app-information-alert>
</div>
